import { render, staticRenderFns } from "./expo-employee-remove.vue?vue&type=template&id=2e745da1"
import script from "./expo-employee-remove.vue?vue&type=script&lang=js"
export * from "./expo-employee-remove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports